import styled, { keyframes } from "styled-components";
import { PlainTextStyle } from "../../styled";

export const SectionStart = styled.section`
    padding: 90px 0;
    height: 100vh;
    @media (max-width: 1199px) {
        padding-top: calc(30px + (60) * ((100vw - 320px) / (1200 - 320)));
        height: auto;
        //padding-bottom: calc(70px + (134) * ((100vw - 320px) / (1200 - 320)));
    }
`;

export const StartContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
    position: relative;
`;

export const StartContent = styled.div`
    position: relative;
    z-index: 1;
`;

export const StartTitle = styled.h1`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 700;
    font-size: 102px;
    line-height: 1.1;
    max-width: 940px;
    margin-bottom: 45px;
    @media (max-width: 1299px) {
        font-size: calc(40px + (68) * ((100vw - 320px) / (1200 - 320)));
        margin-bottom: calc(20px + (25) * ((100vw - 320px) / (1200 - 320)));
    }
`;

export const StartSubtitle = styled.h6`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    font-style: normal;
    line-height: 1.1;
    margin-bottom: 60px;
    font-size: 28px;
    font-weight: 300;
    max-width: 940px;
    @media (max-width: 1199px) {
        //font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320)));
        font-size: 30px;
        line-height: 1.3;
        margin-bottom: 10vh; //calc(20px + (40) * ((100vw - 320px) / (1200 - 320)));
    }
`;

export const StartBookButton = styled.a`
    display: block;
    background: rgb(227, 129, 70);
    border-radius: 45px;
    border: unset;
    outline: none;
    font-weight: 600;
    color: rgb(249, 241, 221);
    font-size: 28px;
    max-width: 320px;
    height: 87px;
    line-height: 87px;
    text-align: center;
    width: 100%;
    text-decoration: unset;
    text-transform: uppercase;
    &:hover {
        opacity: 0.8;
    }
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
        max-width: calc(150px + (170) * ((100vw - 320px) / (1200 - 320)));
        height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
        line-height: calc(35px + (52) * ((100vw - 320px) / (1200 - 320)));
    }
    @media (max-width: 599px) {
        margin: auto;
        font-size: 20px;
        max-width: calc(100vw - 100px);
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const circle = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
`;

export const StartCircle = styled.div`
    position: absolute;
    top: 10%;
    right: -40%;
    width: 800px;
    height: 800px;
    border-radius: 50%;
    background: rgb(249, 241, 221);
    border: 150px solid rgb(238, 210, 177);
    animation-name: ${circle};
    animation-duration: 6s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    @media (max-width: 767px) {
        width: 700px;
        height: 700px;
        border: 140px solid rgb(238, 210, 177);
    }
    @media (max-width: 599px) {
        width: 400px;
        height: 400px;
        border: 80px solid rgb(238, 210, 177);
    }
`;

export const Partners = styled.div`
    display: flex;
    padding-top: 40px;
    gap: 40px;
    flex-wrap: wrap;
    padding-bottom: 100px;
    align-items: center;
    height: 45px;
`;

export const Partner = styled.div`
    z-index: 2;
    position: relative;
`;

export const PartnerOffsetWrapper = styled.div`
    margin-bottom: ${(props: { bottom: string }) => props.bottom};
`;
